<template>
  <div>
    <CopyWell
      v-if="showContent && storedValue"
      :content="decodeContent"
      :label="control.displayOptions.label"
      :rows="19"
      :showTooltip="true"
      :tooltipLabel="control.displayOptions.tooltip.variables.message"
    />
    <FileInput
      :accept="control.accept"
      :buttonText="buttonText"
      :fileName="fileName"
      :handleValueChange="handleChange"
      :label="control.label"
      :tooltip="control.tooltip"
    />
  </div>
</template>

<script>
import { clone, get } from 'lodash';
import { notify } from 'client/util';
import Constants from 'client/util/Constants';
import CopyWell from 'client/components/FormValidation/CopyWell.vue';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import FileInput from 'client/components/FormValidation/FileInput.vue';
import FileUtil from 'client/util/FileUtil';
import format from 'xml-formatter';

const { error, success } = Constants;
export default {
  name: 'DynamicControlsFileInput',

  components: {
    CopyWell,
    FileInput,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    value: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      fileName: this.control.fileName,
      storedValue: '',
    };
  },

  computed: {
    buttonText() {
      if (this.control && this.control.buttonText) {
        return this.control.buttonText;
      }

      if (this.value) {
        return 'replace file';
      }

      return 'upload file';
    },

    decodeContent() {
      let decodedContent = '';

      if (this.storedValue) {
        decodedContent = atob(this.storedValue);
      }

      return format(decodedContent, {
        collapseContent: true,
      });
    },

    showContent() {
      const displayoptionsType = get(this.control, 'displayOptions.type', '');

      return displayoptionsType === 'xml';
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    handleChange(event) {
      // If control.fileName is undefined, it's coming from Applications
      // or the MDM custom configuration profile. If from the latter, we
      // need to check to see if the control has a handleValueChange method.
      if (this.fileName === undefined && this.control.handleValueChange) {
        this.control.handleValueChange(event);
      } else {
        FileUtil.readFileInputValue(event.target, this.control).then((response) => {
          this.handleValueChange(this.control.id, response);
          this.fileName = get(event, 'target.files[0].name', '');
          notify(success, 'The file has been uploaded successfully');
        }, (readError) => {
          notify(error, readError.message);
        });
      }
    },

    handleMounted() {
      this.storedValue = clone(this.value);
    },
  },
};
</script>
